import { FC } from 'react';
import useClientSideMediaQuery from 'hooks/use-client-side-media-query';
import { TextButtonProps } from '../../TextButton';
import CarouselButton from './carousel-button';
import { TypeBody } from '../../Typography';
import { ReviewProps } from '../../ReviewCarousel';
import { VideoProps } from 'components/home/content/review-carousel.content';

import {
  ProductAction,
  DotsPagination,
  Dot,
  ReviewWrapper,
  ReviewThumbsWrapper,
  ReviewThumb,
} from './carousel-elements.styled';
import { ProductCarouselItemType } from 'components/home/content/product-carousel.content';

interface CarouselBottomBarProps {
  button?: TextButtonProps;
  items: ProductCarouselItemType[];
  reviews?: ReviewProps;
  activeIndex?: number;
  showDot?: boolean;
  justify?: string;
  visibleItems?: number[];
  color: 'seedgreen' | 'snowwhite';
}

const CarouselBottomBar: FC<CarouselBottomBarProps> = ({
  button,
  items,
  reviews,
  activeIndex,
  showDot = true,
  justify,
  visibleItems = [],
  color,
}) => {
  const isSmall = useClientSideMediaQuery(960);

  return (
    <ProductAction justify={justify ?? 'space-between'}>
      {reviews && (
        <ReviewWrapper>
          <ReviewThumbsWrapper>
            {reviews.videos.map((review: VideoProps, index: number) => (
              <ReviewThumb
                key={index}
                style={{ marginLeft: `-${index * 5}px` }}
              >
                <img src={review.thumb} alt={review.title} />
              </ReviewThumb>
            ))}
          </ReviewThumbsWrapper>
          <TypeBody color='primary'>{reviews.videos.length} Reviews</TypeBody>
        </ReviewWrapper>
      )}

      {button && !reviews && <CarouselButton button={button} color={color} />}

      {(isSmall || items.length > 4) && items && showDot && (
        <DotsPagination>
          {items.map((_, index) => (
            <Dot
              $color={color}
              key={index}
              animate={
                visibleItems.includes(index) && activeIndex == index
                  ? {
                      width: '16px',
                      borderRadius: '99em',
                      opacity: 1,
                    }
                  : {
                      width: '8px',
                      borderRadius: '50%',
                      opacity: 0.2,
                    }
              }
              className={visibleItems.includes(index) ? 'active' : undefined}
            ></Dot>
          ))}
        </DotsPagination>
      )}
    </ProductAction>
  );
};

export default CarouselBottomBar;
